import { FC, ReactElement } from 'react';
import { useCallStateHooks } from '@stream-io/video-react-sdk';
import { MicMute } from 'react-bootstrap-icons';
import i18next from 'i18next';

const SpeakingWhileMutedToast: FC = (): ReactElement | null => {
  const { useMicrophoneState } = useCallStateHooks();
  const { isSpeakingWhileMuted } = useMicrophoneState();

  if (!isSpeakingWhileMuted) {
    return null;
  }

  return (
    <div className="d-flex justify-content-center pb-1">
      <div
        className="d-flex align-items-center gap-2 px-4 py-2 rounded-pill"
        style={{
          backgroundColor: 'rgba(248, 113, 113, 0.15)',
          border: '1px solid rgba(248, 113, 113, 0.4)',
          color: '#fca5a5',
          fontSize: '0.875rem',
          fontWeight: 600,
          backdropFilter: 'blur(8px)',
        }}
      >
        <MicMute size={14} />
        {i18next.t('callPage.speakingWhileMuted')}
      </div>
    </div>
  );
};

export default SpeakingWhileMutedToast;